module.exports = __webpack_public_path__ + "img/title1.961d62b9.png";